/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {Link} from "react-router-dom";

export function NavPanel({ className,link,icon,text }) {
	return (
		<>
			<Link to={link} className={`nav-link border py-10 d-flex flex-grow-1 rounded flex-column align-items-center ${className}`}>
				{/* Body */}
				<span className={'nav-icon py-2 w-auto'}>
					<span className={'svg-icon svg-icon-3x'}>
						{icon}
					</span>
				</span>
				<span className={'nav-text font-size-lg py-2 font-weight-bolder text-center'}>
					{text}
				</span>
			</Link>
		</>
	);
}
